module.exports = __webpack_public_path__ + "static/media/concept-energy-label-d.581907b7.svg";